<template>
    <section class="section-module managebooking-module">
        <!-- Loading -->
        <loading />

        <!-- Module Content -->
        <div class="module-content d-flex flex-column">
            <!-- Module Header -->
            <div
                class="module-header d-flex flex-column"
                :id="`${modulename}_header`"
                ref="moduleheader"
            >
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="button-body"
                    >
                        Menu
                    </p>
                </div>

                <div class="d-flex flex-column">
                    <h1 class="title-content heading-4">Reservas</h1>
                    <p class="color-text-body">Gere as tuas reservas</p>
                </div>

                <!-- Filter and Search -->
                <div class="module-first-header">
                    <!-- Only Show Search and Filter for Manage Booking Data -->
                    <template v-if="!showweekbookingdata && !showcreatebooking">
                        <div
                            class="second-content d-flex flex-row align-items-center"
                        >
                            <input
                                type="search"
                                placeholder="Nome, espaço ou ID"
                                v-model="search"
                                id="managebooking-search"
                                ref="managebookingsearch"
                                @keyup="searchRoutine($event)"
                            />
                        </div>

                        <div
                            class="third-content d-flex flex-row align-items-center"
                        >
                            <span
                                role="button"
                                class="module-filter-btn"
                                id="module-filter-btn"
                                @click="showModal('filtermodal')"
                            >
                                <img :src="filtericon" alt="Filter Data" />
                            </span>
                            <span class="totalfilterselected-counter">{{
                                totalfilterselected
                            }}</span>
                        </div>

                        <div
                            v-if="!showweekbookingdata && !showcreatebooking"
                            class="clear-filter-btn-wrapper"
                        >
                            <button
                                type="button"
                                class="btn btn-filled-blue button-body"
                                aria-describedby="Clean Filter"
                                @click="removeAllFilters()"
                            >
                                Limpar
                            </button>
                        </div>
                    </template>
                </div>

                <!-- Button Actions -->
                <div class="module-secode-header-base">
                    <div class="module-second-header">
                        <span
                            v-for="(value, index) in buttonsListName"
                            :key="value.id"
                            role="button"
                            :data-referindex="index"
                            :data-action="value.action"
                            :class="
                                value.id === 1
                                    ? 'button-body selected buttonlist'
                                    : 'button-body buttonlist'
                            "
                            ref="buttonlist"
                            @click="buttonsActions($event)"
                        >
                            {{ value.name }}
                        </span>
                    </div>

                    <button
                        type="button"
                        class="btn btn-primary btn-create-booking buttonlist"
                        data-action="create"
                        @click="buttonsActions($event)"
                    >
                        Criar reserva
                    </button>
                </div>
            </div>

            <!-- Base Content -->
            <template v-if="!showpdpbooking">
                <div class="base-content" :class="basecontentclassvariable">
                    <!-- Show Booking Data -->
                    <template v-if="!showweekbookingdata && !showcreatebooking">
                        <!--Module Content -->
                        <template
                            v-if="Object.values(manageBooking).length > 0"
                        >
                            <div class="table-scroll-wrapper desktop-only">
                                <!-- Page List Render-->
                                <table-element
                                    :classname="[
                                        'table-striped',
                                        'managebooking-content',
                                    ]"
                                >
                                    <!-- THead -->
                                    <template #thead>
                                        <tr>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body"
                                                    style="
                                                        border: none;
                                                        padding-left: 0px;
                                                    "
                                                >
                                                    ID da reserva
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="strong-600 color-text-body border-left"
                                                >
                                                    Utilizador
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Espaço
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Reserva
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Pedidos
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Data
                                                </p>
                                            </th>
                                        </tr>
                                    </template>

                                    <!-- Tbody -->
                                    <template #tbody>
                                        <template
                                            v-for="(
                                                value, index
                                            ) in manageBooking"
                                            :key="index"
                                        >
                                            <tr
                                                v-for="(valbooking, indexbooking) in value.booking_data"
                                                :data-referindex="index"
                                                :data-bookingid="
                                                    value.booking_id
                                                "
                                                :data-bookingdataindex="indexbooking"
                                                @click="showPdpBooking($event)"
                                            >
                                                <th scope="row">
                                                    <p class="booking-id">
                                                        {{
                                                            value.manage_booking_id
                                                        }}
                                                    </p>
                                                </th>
                                                <td>
                                                    <p
                                                        class="professional-name border-left strong-600"
                                                    >
                                                        {{
                                                            value.professional_name
                                                        }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p
                                                        class="office-name border-left"
                                                    >
                                                        {{ value.office_name }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <div class="border-left">
                                                        <p
                                                            :class="setStatucClassname(
                                                                valbooking.day,
                                                                valbooking.month,
                                                                valbooking.year,
                                                                value.booking_dates,
                                                                true
                                                            )"
                                                            class="booking-status"
                                                        >
                                                            {{
                                                                setStatucClassname(
                                                                    valbooking.day,
                                                                    valbooking.month,
                                                                    valbooking.year,
                                                                    value.booking_dates,
                                                                    false
                                                                )
                                                            }}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="border-left">
                                                        <p
                                                            :class="
                                                                statusClassname(
                                                                    feedbackConditional(
                                                                        value.booking_data,
                                                                        value.feddback_data,
                                                                        valbooking.month,
                                                                        valbooking.year
                                                                    )
                                                                )
                                                            "
                                                            class="requests-feedback"
                                                        >
                                                            {{
                                                                feedbackConditional(
                                                                    value.booking_data,
                                                                    value.feddback_data,
                                                                    valbooking.month,
                                                                    valbooking.year
                                                                )
                                                            }}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p class="border-left">
                                                        {{ `${valbooking.day}-${valbooking.month}-${valbooking.year}` }}
                                                    </p>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </table-element>
                            </div>

                            <!-- Mobile Card List Render -->
                            <div class="booking-mobile-section mobile-only">
                                <div
                                    class="booking-mobile-card-wrapper"
                                    v-for="(value, index) in manageBooking"
                                    :key="index"
                                >
                                    <div
                                        v-for="(valbooking, indexbooking) in value.booking_data"
                                        :data-referindex="index"
                                        :data-bookingid="value.booking_id"
                                        :data-bookingdataindex="indexbooking"
                                        @click="showPdpBooking($event)"
                                        class="booking-mobile-card"
                                    >
                                        <div class="card-header">
                                            <div
                                                class="professional-name strong-600"
                                            >
                                                {{ value.professional_name }}
                                            </div>
                                            <div
                                                class="booking-id caption-lg color-text-body"
                                            >
                                                <span
                                                    class="color-text-action caption-lg"
                                                    >ID:
                                                </span>
                                                {{ value.manage_booking_id }}
                                            </div>
                                        </div>

                                        <div class="card-body">
                                            <div class="item-wrapper">
                                                <p
                                                    class="color-text-body caption-lg"
                                                >
                                                    Espaço:
                                                </p>
                                                <p class="office-name black">
                                                    {{ value.office_name }}
                                                </p>
                                            </div>
                                            <div class="item-wrapper">
                                                <p
                                                    class="color-text-body caption-lg"
                                                >
                                                    Reserva:
                                                </p>
                                                <p
                                                    class="booking-status"
                                                    :class="setStatucClassname(
                                                        valbooking.day,
                                                        valbooking.month,
                                                        valbooking.year,
                                                        value.booking_dates,
                                                        true
                                                    )"
                                                >
                                                    {{
                                                        setStatucClassname(
                                                            valbooking.day,
                                                            valbooking.month,
                                                            valbooking.year,
                                                            value.booking_dates,
                                                            false
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <div class="item-wrapper">
                                                <p
                                                    class="color-text-body caption-lg"
                                                >
                                                    Pedidos:
                                                </p>
                                                <p
                                                    class="requests-feedback"
                                                    :class="
                                                        statusClassname(
                                                            feedbackConditional(
                                                                value.booking_data,
                                                                value.feddback_data,
                                                                valbooking.month,
                                                                valbooking.year
                                                            )
                                                        )
                                                    "
                                                >
                                                    {{
                                                        feedbackConditional(
                                                            value.booking_data,
                                                            value.feddback_data,
                                                            valbooking.month,
                                                            valbooking.year
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <div class="item-wrapper">
                                                <p
                                                    class="color-text-body caption-lg"
                                                >
                                                    Data:
                                                </p>
                                                <p class="booking-date">
                                                    {{ `${valbooking.day}-${valbooking.month}-${valbooking.year}` }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <h2 class="heading-6" style="padding: 16px">
                                Sem dados para apresentar
                            </h2>
                        </template>
                    </template>

                    <template v-else>
                        <!-- Show Week Booking Data -->
                        <template v-if="showweekbookingdata">
                            <week-booking
                                :booking="JSON.stringify(weekManageBooking)"
                                :notifyurl="notifyurl"
                                :csrftolken="csrftolken"
                                classname="week-base-content-new"
                                routeisadminbooking="admin"
                            />
                        </template>

                        <!-- Show Create Booking -->
                        <template v-if="showcreatebooking">
                            <booking-create
                                :customdata="customdata"
                                :csrftolken="csrftolken"
                                :bookingurl="bookingurl"
                                :statusclassname="statusClassname"
                                :activeurl="activeurl"
                            />
                        </template>
                    </template>
                </div>

                <!-- Load More Booking Data -->
                <div
                    v-if="
                        (Object.values(manageBooking).length > 0) &
                        !showweekbookingdata &
                        !showcreatebooking
                    "
                    class="load-button-base d-flex flex-row justify-content-center"
                >
                    <button
                        class="btn btn-primary btn-show-more-data"
                        type="button"
                        aria-describedby="Load Data Button"
                        @click="loadData()"
                        :disabled="disabledload"
                    >
                        Mostrar mais dados
                    </button>
                </div>
            </template>

            <!-- PDP Content -->
            <template v-else>
                <div
                    class="pdpmanagebooking-content booking-pdp"
                    ref="pdpmanagebooking"
                >
                    <!-- First Content -->
                    <div class="first-content d-flex flex-column">
                        <div class="icon-text-wrapper mb-tablet-only">
                            <p
                                @click="turnBack()"
                                role="button"
                                class="turnback"
                            >
                                Reservas
                            </p>
                        </div>

                        <h2 class="pdp-professional-name heading-4">
                            {{ pdpshowbookingdata.professional_name }}
                        </h2>

                        <p class="color-text-action body-1">
                            ID:
                            <span class="color-text-body">
                                {{ `${pdpshowbookingdata.manage_booking_id}` }}
                            </span>
                        </p>
                    </div>

                    <!-- Second Content -->
                    <div class="second-content">
                        <h3
                            class="body-1 strong-600 second-content-section-title"
                        >
                            Detalhes da reserva
                        </h3>

                        <div class="second-content-container">
                            <div class="title-content">
                                <p
                                    class="booking-status"
                                    :class="`${statusClassname(
                                        pdpshowbookingdata.booking_date_pdp
                                            .booking_status
                                    )}`"
                                >
                                    {{
                                        pdpshowbookingdata.booking_date_pdp
                                            .booking_status
                                    }}
                                </p>
                                <h4 class="heading-6">
                                    {{ pdpshowbookingdata.office_name }}
                                </h4>
                            </div>

                            <div class="content-info">
                                <p class="content-info-date">
                                    {{
                                        pdpshowbookingdata.booking_date_pdp.date
                                    }}
                                </p>

                                <p class="content-info-hour">
                                    {{
                                        `${pdpshowbookingdata.booking_hour_pdp.turndata.begin}:00 - ${pdpshowbookingdata.booking_hour_pdp.turndata.end}:00`
                                    }}
                                </p>
                            </div>
                            <p class="third-content-info-total">
                                Total:
                                {{ `${pdpshowbookingdata.total_hour} hora(s)` }}
                            </p>
                        </div>
                    </div>

                    <h3 class="strong-600 section-title body-1">
                        Pedidos do utilizador
                    </h3>

                    <!-- Third Content -->
                    <div class="third-content">
                        <div
                            v-if="
                                Array.isArray(pdpshowbookingdata.feddback_data)
                            "
                            class="third-content-container d-flex flex-column"
                        >
                            <!-- Card Info -->
                            <div
                                v-for="(
                                    value, index
                                ) in pdpshowbookingdata.feddback_data"
                                :key="index"
                                class="third-content-card d-flex flex-column"
                            >
                                <div
                                    role="button"
                                    class="first-line"
                                    @click="showHideRequest($event)"
                                >
                                    <div class="first-line-title">
                                        <p
                                            class="strong-500 color-text-action heading-6"
                                        >
                                            {{
                                                `${getRequestStatus(
                                                    value.data.subject
                                                )}`
                                            }}
                                            <span class="two-dots">:</span>
                                            &nbsp;
                                        </p>
                                        <small class="body-1"
                                            >{{
                                                `  para ${value.data.booking.date} `
                                            }}
                                            &nbsp;</small
                                        >

                                        <div
                                            :class="`body-1 ${statusClassname(
                                                value.form_status
                                            )}`"
                                        >
                                            {{ value.form_status }}
                                        </div>
                                    </div>

                                    <img
                                        :src="`${defaultpathimg}/keyboard_arrow_down_blue.svg`"
                                        alt="Filter Icon"
                                        class="icon-request"
                                    />
                                </div>

                                <div class="request-content d-none">
                                    <div class="second-line">
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <span class="body-1 color-text-body"
                                                >Mensagem:
                                            </span>
                                            <span
                                                class="caption-lg color-text-body"
                                                >{{ value.created_at }}</span
                                            >
                                        </div>

                                        <p class="message">
                                            {{ value.data.message }}
                                        </p>
                                    </div>

                                    <div
                                        v-if="value.not_response_form"
                                        class="third-line"
                                    >
                                        <div
                                            class="third-line-container-wrapper"
                                        >
                                            <strong class="body-1 strong-600"
                                                >Resposta:</strong
                                            >

                                            <textarea
                                                @focusin="
                                                    inputValidationCase(
                                                        `message${index}`,
                                                        message
                                                    )
                                                "
                                                @focusout="
                                                    inputValidationCase(
                                                        `message${index}`,
                                                        message
                                                    )
                                                "
                                                class="form-control body-1"
                                                v-model="message"
                                                :id="`message${index}`"
                                                maxlength="400"
                                            ></textarea>
                                        </div>

                                        <div class="buttons-base">
                                            <button
                                                type="button"
                                                class="btn btn-danger"
                                                :data-formid="value.form_id"
                                                :data-subject="
                                                    value.data.subject
                                                "
                                                :data-feedbackid="index"
                                                data-action="refused"
                                                :disabled="disabled"
                                                @click="sendData($event)"
                                            >
                                                Recusar pedido
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                :data-formid="value.form_id"
                                                :data-subject="
                                                    value.data.subject
                                                "
                                                :data-feedbackid="index"
                                                data-action="accept"
                                                :disabled="disabled"
                                                @click="sendData($event)"
                                            >
                                                Aceitar pedido
                                            </button>
                                        </div>
                                    </div>

                                    <div v-else class="second-line-v-else">
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <span class="body-1 color-text-body"
                                                >Resposta:
                                            </span>
                                            <span
                                                class="caption-lg color-text-body"
                                                >{{ value.updated_at }}</span
                                            >
                                        </div>

                                        <p class="message">
                                            {{ value.form_response }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <p class="color-text-body no-requests-msg">
                                Este utilizador não possui pedidos
                            </p>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <!-- Fifth Content -->
                    <div class="fifthy-content">
                        <p class="fifthy-content-title strong-600">
                            Detalhes do utilizador
                        </p>

                        <div class="fifthy-content-info d-flex flex-column">
                            <figure>
                                <!-- trocar imagem -->
                                <img
                                    :src="pdpshowbookingdata.professional_image"
                                    alt="User Image"
                                />

                                <figcaption>
                                    <p class="heading-6">
                                        {{
                                            pdpshowbookingdata.professional_name
                                        }}
                                    </p>

                                    <div class="desktop-flex">
                                        <a
                                            :href="`mailto:${pdpshowbookingdata.professional_mail}`"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-describedby="Send Mail"
                                            class="email body-1"
                                            >{{
                                                pdpshowbookingdata.professional_mail
                                            }}</a
                                        >

                                        <a
                                            :href="`tel:+351${pdpshowbookingdata.professional_contact.contact}`"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-describedby="Call User"
                                            class="phone body-1"
                                        >
                                            {{
                                                pdpshowbookingdata
                                                    .professional_contact
                                                    .contact
                                            }}
                                        </a>
                                    </div>
                                </figcaption>
                            </figure>
                        </div>
                    </div>

                    <!-- Sixth Content -->
                    <div
                        v-if="
                            pdpshowbookingdata.professional_history.length > 0
                        "
                        class="sixth-content history-content"
                    >
                        <div class="sixth-content-title-wrapper">
                            <p class="sixth-content-title strong-600">
                                Últimas Reservas
                            </p>
                            <a
                                :href="`${usermoduleurl}/usershow=${pdpshowbookingdata.user_id}`"
                                target="_self"
                                aria-label="Professional History Link"
                                >Ver Todos</a
                            >
                        </div>

                        <figure
                            v-for="(
                                value, index
                            ) in pdpshowbookingdata.professional_history"
                            :key="index"
                        >
                            <div class="img-wrapper">
                                <img
                                    :src="value.office_media[0].files.thumb"
                                    :alt="value.office_name"
                                />
                            </div>

                            <figcaption>
                                <h6 class="card-title">
                                    {{ value.office_name }}
                                </h6>
                                <template
                                    v-for="(
                                        valbooking, indexbooking
                                    ) in value.booking_data"
                                    :key="indexbooking"
                                >
                                    <div class="card-information-wrapper">
                                        <p class="card-date">
                                            {{
                                                `${valbooking.day} de ${valbooking.monthname} de ${valbooking.year}`
                                            }}
                                        </p>
                                        <p class="card-hour">
                                            {{
                                                `${valbooking.turndata.begin}:00-${valbooking.turndata.end}:00`
                                            }}
                                        </p>
                                    </div>
                                </template>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </template>
        </div>

        <!-- Back To Top -->
        <back-to-top :idhref="`${modulename}_header`" />

        <!-- Modal -->
        <modal title="Filtros" classname="filtermodal">
            <template #modalcontent>
                <div class="modalfiler-base">
                    <!-- Filter Header -->
                    <div class="modalfiler-primary-header">
                        <h2 class="heading-6">
                            Filtros<span ref="filtterlength"
                                >({{ computedTotalFilter }})</span
                            >
                        </h2>
                        <span
                            role="button"
                            class="btn-removefilter button-body color-text-action"
                            data-indicate="all"
                            @click="removeAllFilters()"
                        >
                            Remover Filtros
                        </span>
                    </div>

                    <!-- Filter by Date -->

                    <div class="modalfiler-secundary-header">
                        <h6 class="body-1 strong-600">Data</h6>
                        <span
                            role="button"
                            class="btn-removefilter button-body color-text-action"
                            data-indicate="dateInputValue"
                            @click="cleanFilter($event)"
                        >
                            Limpar
                        </span>
                    </div>

                    <div class="filter-option" data-indicate="date">
                        <label class="date-wrapper">
                            <input
                                ref="dateInput"
                                type="date"
                                class="form-control"
                                :min="dateInputCurrentYear"
                                :max="dateInputToday"
                                placeholder="dd-mm-yyyy"
                                id="date"
                                v-model="dateInputValue"
                                @change="filterValueByDate()"
                            />
                            <span
                                class="overlay"
                                @click="openDatePicker"
                            ></span>
                        </label>
                    </div>

                    <!-- Booking Status -->
                    <div class="row-filter status-row-filter">
                        <div class="row-filter-structure">
                            <span
                                role="button"
                                class="deep-filter title-and-icon"
                                data-indicate="bookingstatus"
                                @click="showFilterList($event)"
                            >
                                <span class="filter-show-list">
                                    <img
                                        :src="`${defaultpathimg}/expand_more_down.svg`"
                                        alt="Filter Icon"
                                    />
                                </span>
                                <p class="filter-type-title body-1 strong-600">
                                    Estado da reserva ({{
                                        filterSelected.bookingstatus.total
                                    }})
                                </p>
                            </span>
                            <span
                                role="button"
                                class="deep-filter button-body color-text-action"
                                data-indicate="bookingstatus"
                                @click="cleanFilter($event)"
                                >Limpar</span
                            >
                        </div>

                        <div class="filter-items-group-wraper">
                            <div class="selected-list d-none">
                                <div
                                    v-for="(
                                        valbooking, indexbooking
                                    ) in bookingstatus"
                                    class="form-check"
                                    :key="valbooking.id"
                                    data-indicate="bookingstatus"
                                    :data-referindex="indexbooking"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :value="valbooking.id"
                                        :id="`bookingcheck_${indexbooking}`"
                                        data-indicate="bookingstatus"
                                        :data-referindex="indexbooking"
                                        @click="chooseItems($event)"
                                    />
                                    <label
                                        class="form-check-label button-body"
                                        :for="`bookingcheck_${indexbooking}`"
                                    >
                                        {{ valbooking.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Request Status -->
                    <div class="row-filter type-row-filter">
                        <div class="row-filter-structure">
                            <span
                                role="button"
                                class="deep-filter title-and-icon"
                                data-indicate="requeststatus"
                                @click="showFilterList($event)"
                            >
                                <span class="filter-show-list">
                                    <img
                                        :src="`${defaultpathimg}/expand_more_down.svg`"
                                        alt="Filter Icon"
                                    />
                                </span>
                                <p class="filter-type-title body-1 strong-600">
                                    Tipo de pedido ({{
                                        filterSelected.requeststatus.total
                                    }})
                                </p>
                            </span>
                            <span
                                role="button"
                                class="deep-filter button-body color-text-action"
                                data-indicate="requeststatus"
                                @click="cleanFilter($event)"
                                >Limpar</span
                            >
                        </div>

                        <div class="filter-items-group-wraper">
                            <div class="selected-list d-none">
                                <div
                                    v-for="(
                                        valbooking, indexbooking
                                    ) in requeststatus"
                                    class="form-check"
                                    :key="valbooking.id"
                                    :data-referindex="indexbooking"
                                    data-indicate="requeststatus"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :value="valbooking.id"
                                        :id="`requestcheck_${indexbooking}`"
                                        data-indicate="requeststatus"
                                        :data-referindex="indexbooking"
                                        @click="chooseItems($event)"
                                    />
                                    <label
                                        class="form-check-label button-body"
                                        :for="`requestcheck_${indexbooking}`"
                                    >
                                        {{ valbooking.value }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Apply Filter -->
                    <div class="row-filter btns-row-filter">
                        <div class="btns-wrapper">
                            <button
                                type="button"
                                class="btn btn-primary w-100 btn-filled-blue btn-body"
                                @click="filterRoutine()"
                            >
                                Aplicar Filtros
                            </button>

                            <button
                                type="button"
                                class="btn btn-cancel w-100 btn-filled-white btn-body"
                                @click="hideModal('filtermodal')"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>

<script>
import fetchData from "../../../fetchData";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import Table from "./../../elements/TableElement.vue";
import Pagination from "./../../elements/PaginationElement.vue";
import BackToTop from "./../../elements/BackToTopElement.vue";
import responseMessage from "./../../../responseMessage.js";
import inputValidation from "./../../../validationInputs.js";
import Modal from "./../../elements/ModalElement.vue";
import BookingAdmin from "./BookingAdmin.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";
import BookingAdminCreate from "./BookingAdminCreate.vue";

("use strict");

export default {
    name: "ManageBooking",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        modulesearch: {
            type: String,
            required: true,
        },
        moduleorder: {
            type: String,
            required: true,
        },
        modulefilter: {
            type: String,
            required: true,
        },
        totalpages: {
            type: String,
            required: false,
        },
        firstpage: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        filtericon: {
            type: String,
            required: true,
        },
        defaultpathimg: {
            type: String,
            required: true,
        },
        notifyurl: {
            type: String,
            required: true,
        },
        typeofrequest: {
            type: String,
            required: true,
        },
        messageurl: {
            type: String,
            required: true,
        },
        loadataurl: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: true,
        },
        bookingurl: {
            type: String,
            required: true,
        },
        activeurl: {
            type: String,
            required: true,
        },
        usermoduleurl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            allData: {},
            activeclass: "d-flex",
            filePageUrl: "",
            showpdpbooking: false,
            search: "",
            buttonsListName: [
                {
                    id: 1,
                    name: "Ativas",
                    action: "current",
                },
                {
                    id: 2,
                    name: "Passadas",
                    action: "old",
                },
                {
                    id: 3,
                    name: "Canceladas",
                    action: "cancel",
                },
                {
                    id: 4,
                    name: "Visão Semanal",
                    action: "week",
                },
            ],
            dateInputToday: "",
            dateInputCurrentYear: "",
            dateInputValue: "",
            filterData: {},
            filterSelected: {
                bookingstatus: {
                    data: [],
                    total: 0,
                },
                requeststatus: {
                    data: [],
                    total: 0,
                },
                dateInputValue: 0,
                totalfilter: 0,
            },
            bookingstatus: [
                {
                    id: 1,
                    name: "Ativa",
                },
                {
                    id: 2,
                    name: "Concluída",
                },
                {
                    id: 3,
                    name: "A decorrer",
                },
                {
                    id: 4,
                    name: "Cancelada",
                },
            ],
            requeststatus: [],
            currentManageBooking: [],
            oldManageBooking: [],
            weekManageBooking: [],
            cancelManageBooking: [],
            manageBooking: [],
            showweekbookingdata: false,
            searchData: [],
            totalfilterselected: 0,
            pdpshowbookingdata: {},
            message: "",
            disabled: true,
            disabledload: false,
            offset: 1,
            defaultListKeys: ["current", "old", "week", "cancel"],
            bookingLoadData: {},
            responseTimeOut: 5000,
            showcreatebooking: false,
            basecontentclassvariable: "",
        };
    },
    created() {
        //Set Module Data
        this.allData = JSON.parse(this.moduledata);

        //Set Request Status
        this.requeststatus = JSON.parse(this.typeofrequest);

        //Check Module Data
        if (
            Object.hasOwn(this.allData, "current") &&
            Object.hasOwn(this.allData, "old")
        ) {
            //Separate Manage Booking
            this.defaultListKeys.forEach((value) => {
                this.$data[`${value}ManageBooking`] = this.allData[value];
            });

            //Active Current ManageBooking Data
            this.buttonsActions();
        }

        //Set Review Page Url
        this.filePageUrl = this.firstpage + "/page=";

        //Set Current Year
        let date = new Date();

        const ultimoDiaDoMes = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0
        );

        //Set Last Day of Current Month
        this.dateInputToday =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            ultimoDiaDoMes;

        //Set Only Date from Current Year
        this.dateInputCurrentYear = date.getFullYear() + "-01-01";
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        setStatucClassname(day, month, year, bookingdates, toclass){

            let status = bookingdates.data.find((value) =>
                year === value.year &&
                month === value.month &&
                day === value.day
            );

            return toclass ? this.statusClassname(status.booking_status) : status.booking_status;

        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        inputValidationCase(inputid, inputvalue) {
            if (inputvalue === "") {
                this.disabled = true;

                return;
            }

            //Check Inputs
            if (inputvalue !== "" && inputvalue.length <= 400) {
                this.disabled = inputValidation.validNameCases(4, inputvalue)
                    ? false
                    : true;
            }

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        showHideRequest(element) {
            //Get Response | Request Element
            let responseElement = element.currentTarget.nextElementSibling;

            //Get Icon element
            let iconelemnt = [...element.currentTarget.children].find(
                (value) => value.nodeName === "IMG"
            );

            if (responseElement.classList.contains("d-none")) {
                //Show
                responseElement.classList.remove("d-none");

                //Change src
                iconelemnt.setAttribute(
                    "src",
                    `${this.defaultpathimg}/keyboard_arrow_up__blue.svg`
                );
            } else {
                //Hide
                responseElement.classList.add("d-none");

                //Change src
                iconelemnt.setAttribute(
                    "src",
                    `${this.defaultpathimg}/keyboard_arrow_down_blue.svg`
                );
            }
        },
        getRequestStatus(statusid) {
            //Get Type of request
            let request = this.requeststatus.find(
                (value) => value.id === statusid
            );

            return request.value;
        },
        showPdpBooking(element) {
            //Hide Module Header
            this.$refs.moduleheader.classList.add("d-none");

            //Get Booking Data
            let bookingData = this.manageBooking.find(
                (value, index) =>
                    index ===
                    parseInt(
                        element.currentTarget.getAttribute("data-referindex")
                    )
            );

            //Set PdpBooking Data
            Object.assign(this.pdpshowbookingdata, bookingData);

            //Get Booking Data
            let bookingDataContent = this.pdpshowbookingdata.booking_data.find(
                (val, index) => index === parseInt(element.currentTarget.getAttribute('data-bookingdataindex'))
            );

            //Set PdpBooking Date
            this.pdpshowbookingdata.booking_date_pdp = this.pdpshowbookingdata.booking_dates.data.find((value) =>
                bookingDataContent.year === value.year &&
                bookingDataContent.month === value.month &&
                bookingDataContent.day === value.day
            );
        
            //Set PdpBooking Hour
            this.pdpshowbookingdata.booking_hour_pdp = Array.isArray(
                this.pdpshowbookingdata.booking_data
            )
                ? bookingDataContent
                : this.pdpshowbookingdata.booking_data;

            //Set Total Hour
            this.pdpshowbookingdata.total_hour = Array.isArray(
                this.pdpshowbookingdata.booking_data
            )
                ? bookingDataContent.turndata.totalhour
                : this.pdpshowbookingdata.booking_data.turndata.totalhour;

            //Set Professional History
            this.pdpshowbookingdata.professional_history = [];

            if (
                Object.hasOwn(
                    this.allData.professional_history,
                    this.pdpshowbookingdata.professional_id
                )
            ) {
                this.pdpshowbookingdata.professional_history =
                    this.allData.professional_history[
                        this.pdpshowbookingdata.professional_id
                    ];
                this.pdpshowbookingdata.professional_history = Object.values(
                    this.pdpshowbookingdata.professional_history
                ).slice(0, 3);
            }

            //console.log(this.pdpshowbookingdata);

            //Show Pdp Content
            this.showpdpbooking = true;
        },
        turnBack() {
            //Hide Module Header
            this.$refs.moduleheader.classList.remove("d-none");

            //Show Pdp Content
            this.showpdpbooking = false;
        },
        statusClassname(statusvalue) {
            let semAcento = statusvalue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            return semAcento.toLowerCase().replace(" ", "-");
        },
        feedbackConditional(bookingdata, feedbackdata, month, year) {
            let feedbackvalue = "Sem pedidos";

            if (!Array.isArray(feedbackdata)) {
                return feedbackvalue;
            }

            feedbackdata.forEach((valfeed) => {
                bookingdata.forEach((valbooking) => {
                    if (
                        valbooking.day === valfeed.data.booking.day &&
                        valfeed.data.booking.month === month &&
                        valfeed.data.booking.year === year &&
                        valbooking.turndata.begin ===
                            valfeed.data.booking.begin &&
                        valbooking.turndata.end === valfeed.data.booking.end
                    ) {
                        feedbackvalue = this.requeststatus.find(
                            (valrequest) =>
                                valrequest.id === valfeed.data.subject
                        );
                        feedbackvalue = feedbackvalue.value;
                    }
                });
            });

            return feedbackvalue;
        },
        buttonsActions(element = null, indicate = "current") {
            //Check actions
            let action =
                element !== null
                    ? element.target.getAttribute("data-action")
                    : indicate;

            //Selected Button
            [...document.querySelectorAll(".buttonlist")].forEach((value) => {
                value.classList.remove("selected");

                if (value.getAttribute("data-action") === action) {
                    value.classList.add("selected");
                }
            });

            //Always clean search data
            this.search = "";

            //Show Manage Booking
            this.showweekbookingdata = false;
            this.showcreatebooking = false;

            //Check Action
            switch (action) {
                case "week":
                    this.showweekbookingdata = true;
                    this.basecontentclassvariable = "week-base-content";

                    break;

                case "create":
                    this.showcreatebooking = true;
                    this.basecontentclassvariable = "create-base-content";

                    break;

                default:
                    //Set Manage Booking Data
                    this.manageBooking = this.$data[`${action}ManageBooking`];
                    this.basecontentclassvariable = "";

                    break;
            }
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showModal(classname) {
            //Disabled Button
            this.disabled = true;

            //Show Modal
            $(`.${classname}`).modal("show");
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");
        },
        showFilterList(element) {
            //Element Button
            let elementBtn =
                element.target.nodeName === "SPAN"
                    ? element.target
                    : element.target.parentElement;

            //Check Element
            if (elementBtn.nodeName === "SPAN") {
                //Image
                let iconimg = elementBtn.classList.contains("filter-show-list")
                    ? elementBtn.firstElementChild
                    : elementBtn.firstElementChild.firstElementChild;

                //Chevron Icons
                let icondown = `${this.defaultpathimg}/expand_more_down.svg`;
                let iconup = `${this.defaultpathimg}/expand_less_up.svg`;

                //ElementList
                let elementList = elementBtn.classList.contains("deep-filter")
                    ? elementBtn.parentElement.nextElementSibling
                          .firstElementChild
                    : elementBtn.parentElement.parentElement.nextElementSibling
                          .firstElementChild;

                //Show List
                if (elementList.classList.contains("d-none")) {
                    //Add IconUp
                    iconimg.setAttribute("src", iconup);

                    elementList.classList.remove("d-none");
                } else {
                    //Add IconDown
                    iconimg.setAttribute("src", icondown);

                    elementList.classList.add("d-none");
                }
            }
        },
        chooseItems(element) {
            //Get Filter Indicate
            let filterindicate = element.target.getAttribute("data-indicate");

            //Get Filter Value
            if (this.filterSelected[filterindicate].data.length === 0) {
                this.filterSelected[filterindicate].data.push(
                    this.$data[filterindicate].find(
                        (value) => value.id === parseInt(element.target.value)
                    )
                );
            } else {
                //Check filter value in Filter Selected
                let filterValueExist = this.filterSelected[
                    filterindicate
                ].data.find(
                    (value) => value.id === parseInt(element.target.value)
                );

                if (filterValueExist === undefined) {
                    this.filterSelected[filterindicate].data.push(
                        this.$data[filterindicate].find(
                            (value) =>
                                value.id === parseInt(element.target.value)
                        )
                    );
                } else {
                    let index =
                        this.filterSelected[filterindicate].data.indexOf(
                            filterValueExist
                        );

                    //Remove data from Filter List
                    this.filterSelected[filterindicate].data.splice(index, 1);
                }
            }

            //Set Filter Total by FilterType
            this.filterSelected[filterindicate].total =
                this.filterSelected[filterindicate].data.length;
        },
        cleanFilter(element) {
            //Get Indicate Value
            let indicate = element.target.getAttribute("data-indicate");

            switch (indicate) {
                //dateInputValue
                case "dateInputValue":
                    this.filterSelected[indicate] = 0;
                    this.dateInputValue = "";

                    break;

                //bookingstatus, requeststatus
                case "bookingstatus":
                case "requeststatus":
                    this.filterSelected[indicate].data = [];
                    this.filterSelected[indicate].total = 0;

                    //Remove Checked
                    [...document.querySelectorAll(".form-check-input")].forEach(
                        (value) => {
                            if (
                                value.getAttribute("data-indicate") === indicate
                            ) {
                                value.checked = false;
                            }
                        }
                    );

                    break;
            }
        },
        removeSelectedFilters() {
            //Clear Filter Select Data
            this.filterSelected = {
                bookingstatus: {
                    data: [],
                    total: 0,
                },
                requeststatus: {
                    data: [],
                    total: 0,
                },
                dateInputValue: 0,
                totalfilter: 0,
            };

            this.dateInputValue = "";

            //Set Total from Filter Selected
            this.totalfilterselected = this.computedTotalFilter;

            //Remove Checked
            [...document.querySelectorAll(".form-check-input")].forEach(
                (value) => (value.checked = false)
            );
        },
        removeAllFilters() {
            //Clear Filter Select Data
            this.filterSelected = {
                bookingstatus: {
                    data: [],
                    total: 0,
                },
                requeststatus: {
                    data: [],
                    total: 0,
                },
                dateInputValue: 0,
                totalfilter: 0,
            };

            this.dateInputValue = "";

            //Set Total from Filter Selected
            this.totalfilterselected = this.computedTotalFilter;

            //Remove Checked
            [...document.querySelectorAll(".form-check-input")].forEach(
                (value) => (value.checked = false)
            );

            //Get Selected Button
            let selectedButton = [
                ...document.querySelectorAll(".buttonlist"),
            ].find(
                (value) =>
                    value.classList.contains("selected") &&
                    value.getAttribute("data-action") !== "week"
            );

            //Set Default Booking Data
            this.manageBooking =
                this.$data[
                    `${selectedButton.getAttribute("data-action")}ManageBooking`
                ];
        },
        filterRoutine() {
            //Check Manage Booking Data
            if (
                this.manageBooking.length === 0 ||
                (this.filterSelected.dateInputValue === 0 &&
                    this.filterSelected.bookingstatus.data.length === 0 &&
                    this.filterSelected.requeststatus.data.length === 0)
            ) {
                return;
            }

            //Filter Data Variable
            let filterData = [];

            //Set Total from Filter Selected
            this.totalfilterselected = this.computedTotalFilter;

            //Get Keys from Objetc
            let filterObjcKeys = Object.keys(this.filterSelected);
            let indextotal = filterObjcKeys.indexOf("totalfilter");
            filterObjcKeys.splice(indextotal, 1);

            //Get Data for Filter
            this.manageBooking.forEach((valbooking) => {
                filterObjcKeys.forEach((valfilter) => {
                    switch (typeof this.filterSelected[valfilter]) {
                        //number
                        case "number":
                            if (
                                this.filterSelected[valfilter] > 0 &&
                                Array.isArray(valbooking.booking_data)
                            ) {
                                valbooking.booking_data.forEach((valdates) => {
                                    let month =
                                        valbooking.month < 10
                                            ? `0${valbooking.month}`
                                            : valbooking.month;
                                    let day =
                                        valdates.day < 10
                                            ? `0${valdates.day}`
                                            : valdates.day;

                                    if (
                                        this.filterSelected[valfilter] ===
                                        Date.parse(
                                            `${valbooking.year}-${month}-${day}`
                                        )
                                    ) {
                                        filterData = this.filterConfirmPush(
                                            filterData,
                                            valbooking
                                        );
                                    }
                                });
                            } else {
                                let month =
                                    valbooking.month < 10
                                        ? `0${valbooking.month}`
                                        : valbooking.month;
                                let day =
                                    valbooking.booking_data.day < 10
                                        ? `0${valbooking.booking_data.day}`
                                        : valbooking.booking_data.day;

                                if (
                                    this.filterSelected[valfilter] ===
                                    Date.parse(
                                        `${valbooking.year}-${month}-${day}`
                                    )
                                ) {
                                    filterData = this.filterConfirmPush(
                                        filterData,
                                        valbooking
                                    );
                                }
                            }

                            break;

                        //Object
                        case "object":
                            if (
                                this.filterSelected[valfilter].data.length > 0
                            ) {
                                this.filterSelected[valfilter].data.forEach(
                                    (valstatus) => {
                                        if (Object.hasOwn(valstatus, "name")) {
                                            if (
                                                valstatus.name
                                                    .toLowerCase()
                                                    .replace(" ", "-") ===
                                                valbooking.booking_dates.data.booking_status
                                                    .toLowerCase()
                                                    .replace(" ", "-")
                                            ) {
                                                filterData =
                                                    this.filterConfirmPush(
                                                        filterData,
                                                        valbooking
                                                    );
                                            }
                                        }

                                        if (
                                            Array.isArray(
                                                valbooking.feddback_data
                                            ) &&
                                            Object.hasOwn(valstatus, "value")
                                        ) {
                                            let confirmpush =
                                                valbooking.feddback_data.find(
                                                    (valfeedback) =>
                                                        valfeedback.data
                                                            .subject ===
                                                        valstatus.id
                                                );

                                            //console.log(confirmpush);

                                            if (confirmpush !== undefined) {
                                                filterData =
                                                    this.filterConfirmPush(
                                                        filterData,
                                                        valbooking
                                                    );
                                            }
                                        }
                                    }
                                );
                            }

                            break;
                    }
                });
            });

            //console.log(filterData);

            //Filter Data
            let setFilterData = [];

            filterObjcKeys.forEach((valfilter) => {
                switch (typeof this.filterSelected[valfilter]) {
                    case "number":
                        if (setFilterData.length === 0) {
                            setFilterData = this.filterStructureDataByType(
                                typeof this.filterSelected[valfilter],
                                this.filterSelected[valfilter],
                                setFilterData,
                                filterData
                            );
                        } else {
                            setFilterData = this.filterStructureDataByType(
                                typeof this.filterSelected[valfilter],
                                this.filterSelected[valfilter],
                                setFilterData,
                                setFilterData
                            );
                        }

                        break;

                    case "object":
                        if (setFilterData.length === 0) {
                            setFilterData = this.filterStructureDataByType(
                                typeof this.filterSelected[valfilter],
                                this.filterSelected[valfilter],
                                setFilterData,
                                filterData
                            );
                        } else {
                            setFilterData = this.filterStructureDataByType(
                                typeof this.filterSelected[valfilter],
                                this.filterSelected[valfilter],
                                setFilterData,
                                setFilterData
                            );
                        }

                        break;
                }
            });

            //Set Filter Data for Manage Booking
            this.manageBooking = setFilterData;

            //console.log(setFilterData);

            //Set Total from Filter Selected
            this.totalfilterselected = this.computedTotalFilter;

            //Hide Modal
            this.hideModal("filtermodal");
        },
        filterValueByDate() {
            this.filterSelected.dateInputValue = Date.parse(
                this.dateInputValue
            );

            return this.filterSelected.dateInputValue;
        },
        filterConfirmPush(filterData, valbooking) {
            if (filterData.length === 0) {
                filterData.push(valbooking);
            } else {
                let confirmpush = filterData.find(
                    (valdata) => valdata.booking_id === valbooking.booking_id
                );

                if (confirmpush === undefined) {
                    filterData.push(valbooking);
                }
            }

            return filterData;
        },
        filterStructureDataByType(
            filtertype,
            filterSelected,
            setFilterData,
            filterData
        ) {
            switch (filtertype) {
                case "number":
                    if (filterSelected > 0) {
                        setFilterData = filterData.filter(
                            (valbooking, indexbooking) => {
                                let confirmfilter = null;

                                if (Array.isArray(valbooking.booking_data)) {
                                    valbooking.booking_data.forEach(
                                        (valdates) => {
                                            let month =
                                                valbooking.month < 10
                                                    ? `0${valbooking.month}`
                                                    : valbooking.month;
                                            let day =
                                                valdates.day < 10
                                                    ? `0${valdates.day}`
                                                    : valdates.day;

                                            if (
                                                filterSelected ===
                                                Date.parse(
                                                    `${valbooking.year}-${month}-${day}`
                                                )
                                            ) {
                                                confirmfilter = indexbooking;
                                            }
                                        }
                                    );
                                } else {
                                    let month =
                                        valbooking.month < 10
                                            ? `0${valbooking.month}`
                                            : valbooking.month;
                                    let day =
                                        valbooking.booking_data.day < 10
                                            ? `0${valbooking.booking_data.day}`
                                            : valbooking.booking_data.day;

                                    if (
                                        filterSelected ===
                                        Date.parse(
                                            `${valbooking.year}-${month}-${day}`
                                        )
                                    ) {
                                        confirmfilter = indexbooking;
                                    }
                                }

                                if (confirmfilter !== null) {
                                    return valbooking;
                                }
                            }
                        );
                    }

                    break;

                case "object":
                    if (filterSelected.data.length > 0) {
                        setFilterData = filterData.filter(
                            (valbooking, indexbooking) => {
                                let confirmfilter = null;

                                filterSelected.data.forEach((valstatus) => {
                                    if (Object.hasOwn(valstatus, "name")) {
                                        if (
                                            valstatus.name
                                                .toLowerCase()
                                                .replace(" ", "-") ===
                                            valbooking.booking_dates.data.booking_status
                                                .toLowerCase()
                                                .replace(" ", "-")
                                        ) {
                                            confirmfilter = indexbooking;
                                        }
                                    }

                                    if (
                                        Array.isArray(
                                            valbooking.feddback_data
                                        ) &&
                                        Object.hasOwn(valstatus, "value")
                                    ) {
                                        let confirmpush =
                                            valbooking.feddback_data.find(
                                                (valfeedback) =>
                                                    valfeedback.data.subject ===
                                                    valstatus.id
                                            );

                                        if (confirmpush !== undefined) {
                                            confirmfilter = indexbooking;
                                        }
                                    }
                                });

                                if (confirmfilter !== null) {
                                    return valbooking;
                                }
                            }
                        );
                    }

                    break;
            }

            return setFilterData;
        },
        searchRoutine(element) {
            //Check by Manage Booking Data
            if (
                this.manageBooking.length === 0 &&
                element.key !== "Backspace"
            ) {
                return;
            }

            //Get Selected Button
            let selectedButton = [
                ...document.querySelectorAll(".buttonlist"),
            ].find((value) => value.classList.contains("selected"));

            //Get Action
            let action = selectedButton.getAttribute("data-action");

            //When the key is Backspace return
            if (element.key === "Backspace") {
                //Set Default Manage Booking Data
                this.manageBooking = this.$data[`${action}ManageBooking`];

                //Clean Search Data
                this.searchData = [];

                return;
            }

            //Search type
            let searchType = {
                name: [],
                officename: [],
                manageid: [],
            };

            //Set Search Conditional without comma
            if (!this.search.includes(",")) {
                //Serach Structure
                searchType.name = this.$data[`${action}ManageBooking`].filter(
                    (valbooking) =>
                        valbooking.professional_name
                            .toLowerCase()
                            .includes(this.search.toLowerCase().trim()) ||
                        valbooking.professional_name.toLowerCase() ===
                            this.search.toLowerCase().trim()
                );
                searchType.officename = this.$data[
                    `${action}ManageBooking`
                ].filter(
                    (valbooking) =>
                        valbooking.office_name
                            .toLowerCase()
                            .includes(this.search.toLowerCase().trim()) ||
                        valbooking.office_name.toLowerCase() ===
                            this.search.toLowerCase().trim()
                );
                searchType.manageid = this.$data[
                    `${action}ManageBooking`
                ].filter(
                    (valbooking) =>
                        valbooking.manage_booking_id
                            .toString()
                            .includes(this.search.trim()) ||
                        valbooking.manage_booking_id.toString() ===
                            this.search.trim()
                );

                ["name", "officename", "manageid"].forEach((value) => {
                    if (
                        Array.isArray(searchType[value]) &&
                        searchType[value].length > 0
                    ) {
                        this.manageBooking = searchType[value];

                        return;
                    }
                });

                return;
            }

            //Split Search Value
            if (this.search.includes(",")) {
                //Clean Search Data
                //this.searchData = [];

                let searchSplit = this.search.split(",");

                //Clean searchSplit
                if (searchSplit.includes(" ")) {
                    let index = searchSplit.indexOf(" ");

                    searchSplit.splice(index, 1);
                }

                //Check Length - Limit of Search Values
                if (searchSplit.length > 3) {
                    //Set Default Manage Booking Data
                    this.manageBooking = this.$data[`${action}ManageBooking`];

                    //Clean Search Data
                    this.searchData = [];

                    return;
                }

                //Get SearchData
                let i = 0;
                let firstvalue = 0;
                let secondvalue = 1;
                let thirdvalue = 2;

                //Clean White Empty spaces
                searchSplit = searchSplit.map(
                    (value) => (value = value.toLowerCase().trim())
                );

                do {
                    switch (i) {
                        case 0:
                            if (searchSplit[i] !== " ") {
                                //Serach Structure
                                this.searchData = this.$data[
                                    `${action}ManageBooking`
                                ].filter((value) => {
                                    if (
                                        value.professional_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) ||
                                        value.office_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) ||
                                        value.manage_booking_id
                                            .toString()
                                            .includes(searchSplit[firstvalue])
                                    ) {
                                        return value;
                                    }
                                });
                            }

                            break;

                        case 1:
                            if (searchSplit[i] !== " ") {
                                //Serach Structure
                                this.searchData = this.$data[
                                    `${action}ManageBooking`
                                ].filter((value) => {
                                    if (
                                        (value.professional_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.office_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                )) ||
                                        (value.office_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.manage_booking_id
                                                .toString()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                )) ||
                                        (value.manage_booking_id
                                            .toString()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.professional_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                ))
                                    ) {
                                        return value;
                                    }
                                });
                            }

                            break;

                        case 2:
                            if (searchSplit[i] !== " ") {
                                //Serach Structure
                                this.searchData = this.$data[
                                    `${action}ManageBooking`
                                ].filter((value) => {
                                    if (
                                        (value.professional_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.office_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                ) &&
                                            value.manage_booking_id
                                                .toString()
                                                .includes(
                                                    searchSplit[thirdvalue]
                                                )) ||
                                        (value.office_name
                                            .toLowerCase()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.manage_booking_id
                                                .toString()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                ) &&
                                            value.professional_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[thirdvalue]
                                                )) ||
                                        (value.manage_booking_id
                                            .toString()
                                            .includes(
                                                searchSplit[firstvalue]
                                            ) &&
                                            value.professional_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[secondvalue]
                                                ) &&
                                            value.office_name
                                                .toLowerCase()
                                                .includes(
                                                    searchSplit[thirdvalue]
                                                ))
                                    ) {
                                        return value;
                                    }
                                });
                            }

                            break;
                    }

                    i++;
                } while (i < searchSplit.length);

                this.manageBooking = this.searchData;

                return;
            }
        },
        updatedBookingData(bookingData, action, formid, data) {
            //Change Status Conditional for Request
            bookingData.forEach((value) => {
                if (
                    value.booking_id === this.pdpshowbookingdata.booking_id &&
                    value.office_id === this.pdpshowbookingdata.office_id &&
                    value.order_id === this.pdpshowbookingdata.order_id &&
                    value.professional_id ===
                        this.pdpshowbookingdata.professional_id
                ) {
                    value.feddback_data.map((valfeed) => {
                        if (valfeed.form_id === formid) {
                            valfeed.not_response_form = false;
                            valfeed.form_status =
                                action === "refused" ? "Recusado" : "Aceite";
                            valfeed.form_response = data.response;
                            valfeed.updated_at = data.updatedat;
                        }
                    });

                    //Update Booking Data
                    /* if(Object.values(data.newbooking).length > 0){

                        value.booking_data.map((valbooking, index) => {

                            if(index === this.pdpshowbookingdata.booking_date_pdp.booking_data_index){

                                value.booking_data.splice(index, 1);

                            }

                        });
                        
                        value.booking_dates.map((valbooking, index) => {

                            if(index === this.pdpshowbookingdata.booking_date_pdp.booking_data_index){

                                value.booking_dates.splice(index, 1);

                            }

                        });

                    } */
                }
            });
        },
        sendData(element) {
            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Check per empty values
            if (this.message === "") {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Por favor enviar dados válidos",
                    this.activeclass,
                    5000
                );

                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                return;
            }

            //Data Form
            let dataForm = {
                message: this.message.trim(),
                action: element.target.getAttribute("data-action"),
                status:
                    element.target.getAttribute("data-action") === "refused"
                        ? 3
                        : 2,
                formid: parseInt(element.target.getAttribute("data-formid")),
                subject: parseInt(element.target.getAttribute("data-subject")),
                bookingid: this.pdpshowbookingdata.booking_id,
                officeid: this.pdpshowbookingdata.office_id,
                professionalid: this.pdpshowbookingdata.professional_id,
                orderid: this.pdpshowbookingdata.order_id,
                professionalmail: this.pdpshowbookingdata.professional_mail,
                professionalname: this.pdpshowbookingdata.professional_name,
                manage_booking_id: this.pdpshowbookingdata.manage_booking_id,
                feddback_data:
                    this.pdpshowbookingdata.feddback_data[
                        parseInt(element.target.getAttribute("data-feedbackid"))
                    ],
                booking_data: this.pdpshowbookingdata.booking_data,
            };

            //Send Data
            let response = fetchData.structureTosendData(
                this.messageurl,
                dataForm,
                this.csrftolken,
                "POST"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Update Manage Booking Data
                    if (value.classname === "success") {
                        //Load the page after Cancelation
                        if (dataForm.subject === 2) {
                            window.location.reload();

                            return;
                        }

                        //Get Selected Button
                        let selectedButton = [
                            ...document.querySelectorAll(".buttonlist"),
                        ].find(
                            (value) =>
                                value.classList.contains("selected") &&
                                value.getAttribute("data-action") !== "week"
                        );

                        //Update all related data
                        this.updatedBookingData(
                            this.$data[
                                `${selectedButton.getAttribute(
                                    "data-action"
                                )}ManageBooking`
                            ],
                            element.target.getAttribute("data-action"),
                            dataForm.formid,
                            value.data
                        );
                        this.updatedBookingData(
                            this.manageBooking,
                            element.target.getAttribute("data-action"),
                            dataForm.formid,
                            value.data
                        );
                    }

                    //Clean Object
                    this.message = "";
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        loadData() {
            //Disabled Button
            this.disabledload = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                this.loadataurl,
                { offset: this.offset },
                this.csrftolken,
                "POST"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        5000
                    );

                    //Enabled Button
                    this.disabledload = false;

                    //Check Booking Data
                    this.bookingLoadData = JSON.parse(value.data);

                    if (
                        this.bookingLoadData !== null &&
                        typeof this.bookingLoadData === "object"
                    ) {
                        //Set Module Data
                        this.defaultListKeys.forEach((valrefer) => {
                            if (
                                Array.isArray(this.bookingLoadData[valrefer]) &&
                                this.bookingLoadData[valrefer].length > 0
                            ) {
                                this.bookingLoadData[valrefer].forEach(
                                    (valnew) => {
                                        let dataExist = this.$data[
                                            `${valrefer}ManageBooking`
                                        ].find((valold) => {
                                            if (
                                                valnew.booking_id ===
                                                    valold.booking_id &&
                                                valnew.order_id ===
                                                    valold.order_id &&
                                                valnew.office_id ===
                                                    valold.office_id &&
                                                valnew.professional_id ===
                                                    valold.professional_id
                                            ) {
                                                return valold;
                                            }
                                        });

                                        if (dataExist === undefined) {
                                            this.$data[
                                                `${valrefer}ManageBooking`
                                            ].push(valnew);
                                        }
                                    }
                                );
                            }
                        });

                        //Get Active Button
                        let btnaction = [
                            ...document.querySelectorAll(".buttonlist"),
                        ].find((valbtn) =>
                            valbtn.classList.contains("selected")
                        );

                        //Render new Data
                        this.buttonsActions(
                            null,
                            btnaction.getAttribute("data-action")
                        );

                        //Clear Variable
                        this.bookingLoadData = {};

                        //Conditional for generate more data
                        this.offset++;
                    }

                    return;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabledload = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        openDatePicker() {
            const input = this.$refs.dateInput;
            if (!input) return;

            // p/ browser moderno
            if (typeof input.showPicker === "function") {
                input.showPicker();
            } else {
                // p/ browser antigo
                input.focus();
            }
        },
    },
    computed: {
        computedAllData() {
            return this.allData;
        },
        computedManageBooking() {
            return this.manageBooking;
        },
        computedSearchData() {
            return this.searchData;
        },
        computedTotalFilter() {
            if (
                this.filterSelected.bookingstatus.data.length > 0 ||
                this.filterSelected.requeststatus.data.length > 0 ||
                this.filterSelected.dateInputValue > 0
            ) {
                let indicateforfiltertoltal = [
                    {
                        conditional:
                            this.filterSelected.bookingstatus.data.length > 0,
                        value: 1,
                        type: "bookingstatus",
                    },
                    {
                        conditional:
                            this.filterSelected.requeststatus.data.length > 0,
                        value: 1,
                        type: "requeststatus",
                    },
                    {
                        conditional: this.filterSelected.dateInputValue > 0,
                        value: 1,
                        type: "date",
                    },
                ];

                let sumforfiltertotal = indicateforfiltertoltal.filter(
                    (valfilter) => valfilter.conditional
                );

                //Set Total for Filter Selected
                this.filterSelected.totalfilter = sumforfiltertotal.length;
            } else if (
                this.filterSelected.bookingstatus.data.length === 0 &&
                this.filterSelected.requeststatus.data.length === 0 &&
                this.filterSelected.dateInputValue === 0
            ) {
                this.filterSelected.totalfilter = 0;
            } else {
                --this.filterSelected.totalfilter;
            }

            return this.filterSelected.totalfilter;
        },
    },
    watch: {
        computedAllData() {},
        computedManageBooking() {},
        computedSearchData() {},
        computedTotalFilter() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        tableElement: Table,
        pagination: Pagination,
        backToTop: BackToTop,
        modal: Modal,
        weekBooking: BookingAdmin,
        cardElement: CardElement,
        bookingCreate: BookingAdminCreate,
    },
};
</script>
